// Styles for PointsEarned

import styled from 'styled-components';
import { toRem, baseVariables } from '@marriott/mi-ui-library';
import rtl from 'styled-components-rtl';

export const StyledPointsEarned = styled.div`
  ${rtl`
    .points-earned {
      /* Points number styling */
      &-number {
        width: 100%;
        max-width: ${toRem(32)};
        font-family: SwissCondensed;
      }

      /* Points property card styling */
      &-property {
        background-color: ${baseVariables.color.neutral10};
        border-radius: ${baseVariables.border.borderRadiusDefault};
      }
    }
  `}
`;
